
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ParamStringEditor extends Vue {
    @Prop() leadClassParam!: any;
    @Prop() params!: any[];

    get param() {
        return this.params.find((i: any) => i.leadClassParamId === this.leadClassParam.id);
    }   
}
